import {ref} from "vue";

const useTypewriter = (emit = null) => {
  const typedText = ref('');

  const startTyping = (fullText, speed = 100) => {
    let index = 0;
    typedText.value = '';

    const text = fullText || '';

    const intervalId = setInterval(() => {
      typedText.value += text[index];
      index++;

      // Stop the typing effect when we reach the end of the text
      if (index >= text.length) {
        clearInterval(intervalId);
        if (emit) {
          emit('typewriter-finished');
        }
      }
    }, speed);
  };

  return {
    typedText,
    startTyping,
  };
};

export default useTypewriter;
